
import product from '../../api/product'
import news from '../../api/news'
import axios from 'axios';
import qualification from '../../api/qualification';
import cases from '../../api/case'
import about from '../../api/about'
export default {
    data(){
        return {
            p_swiperOptions: {
                loop : true ,
                pagination: {
                    el: '.swiper-state'
                },
                autoplay:{
                    delay: 5000,
                    enabled: false
                },
                navigation: {
                    nextEl: '.jt-left', 
                    prevEl: '.jt-right'
                },
            },
            m_swiperOptions: {
                loop: true,
                effect: "coverflow", //翻转效果
                centeredSlides: true,
                slidesPerView: "auto",    //设置中间的卡片居中显示
                coverflowEffect: {           // coverflow 效果调整
                rotate: 0,
                stretch: 20,
                depth: 100,
                modifier: 2,
                slideShadows: false
                }
            },
            products : [],
            news : [],
            qualifications : [],
            cases : [],
            about : {},
        }
    },

    created(){
        axios.all([
            product.getHomeProducts({
                num : 5,
            }),
            news.getHomeNews({
                num : 5,
            }),
            qualification.getHomeQua({
                num : 5 ,
            }),
            cases.getHomeProject({
                num : 5 ,
            }),
            about.getCompanyProfile({
            })
        ]).then(axios.spread((productdata, newsdata , qualificationdata ,cases,about)=> {
            // 请求现在都执行完成
            this.products = productdata;
            this.news = newsdata
            this.qualifications = qualificationdata
            this.cases = cases
            this.about = about
          }));
    },

    methods : {
        postProduct(){
            
        },
    }

}